export var RoomTypes;
(function (RoomTypes) {
    RoomTypes["standardRoom"] = "standardRoom";
    RoomTypes["elevatorRoom"] = "elevatorRoom";
    RoomTypes["stairsRoom"] = "stairsRoom";
    RoomTypes["switchFloor"] = "switchFloor";
    RoomTypes["waitingRoom"] = "waitingRoom";
    RoomTypes["cafeteriaRoom"] = "cafeteriaRoom";
    RoomTypes["wcRoom"] = "wcRoom";
    RoomTypes["entranceRoom"] = "entranceRoom";
    RoomTypes["emergencyRoom"] = "emergencyRoom";
    RoomTypes["hiddenRoom"] = "hiddenRoom";
    RoomTypes["waitingArea"] = "waitingArea";
    RoomTypes["cafeteriaArea"] = "cafeteriaArea";
    RoomTypes["emergencyArea"] = "emergencyArea";
    RoomTypes["officeArea"] = "officeArea";
    RoomTypes["mainFloor"] = "mainFloor";
    RoomTypes["sideFloor"] = "sideFloor";
    RoomTypes["restrictedFloor"] = "restrictedFloor";
    RoomTypes["exit"] = "exit";
})(RoomTypes || (RoomTypes = {}));
export var CommonFeatureStates;
(function (CommonFeatureStates) {
    CommonFeatureStates["fillColor"] = "fillColor";
    CommonFeatureStates["height"] = "height";
    CommonFeatureStates["base"] = "base";
})(CommonFeatureStates || (CommonFeatureStates = {}));
const EXPRESSION_PARTS = {
    fillColor: {
        fillColor_check: [
            "boolean",
            ["to-boolean", ["feature-state", CommonFeatureStates.fillColor]],
            false,
        ],
        fillColor: ["feature-state", CommonFeatureStates.fillColor],
    },
};
/**
 * The filters basically mean check if the feature has got the correct type in its properties
 */
export const EXPRESSIONS = {
    roomType: {
        // --- rooms ---
        standardRoom: ["==", ["get", "type"], RoomTypes.standardRoom],
        elevatorRoom: ["==", ["get", "type"], RoomTypes.elevatorRoom],
        stairsRoom: ["==", ["get", "type"], RoomTypes.stairsRoom],
        switchFloorRoom: ["==", ["get", "type"], RoomTypes.switchFloor],
        waitingRoom: ["==", ["get", "type"], RoomTypes.waitingRoom],
        cafeteriaRoom: ["==", ["get", "type"], RoomTypes.cafeteriaRoom],
        wcRoom: ["==", ["get", "type"], RoomTypes.wcRoom],
        entranceRoom: ["==", ["get", "type"], RoomTypes.entranceRoom],
        emergencyRoom: ["==", ["get", "type"], RoomTypes.emergencyRoom],
        // wird zum filtern benutzt
        hiddenRoom: [
            "any",
            ["==", ["get", "type"], RoomTypes.hiddenRoom],
            ["==", ["get", "type"], "hidden"],
        ],
        // --- Areas ---
        waitingArea: ["==", ["get", "type"], RoomTypes.waitingArea],
        cafeteriaArea: ["==", ["get", "type"], RoomTypes.cafeteriaArea],
        emergencyArea: ["==", ["get", "type"], RoomTypes.emergencyArea],
        officeArea: ["==", ["get", "type"], RoomTypes.officeArea],
        // --- floors ---
        mainFloor: ["==", ["get", "type"], RoomTypes.mainFloor],
        sideFloor: ["==", ["get", "type"], RoomTypes.sideFloor],
        restrictedFloor: ["==", ["get", "type"], RoomTypes.restrictedFloor],
        // --- misc ---
        exit: ["==", ["get", "type"], RoomTypes.exit],
        // --- additionals ---
        glass: ["has", "glass"],
        hasHeight: ["has", "height"],
        getHeight: ["get", "height"],
        // --- states ---
        // deprecated: stattdessen werden roomStates, floorStates etc. verwendet
        highlight: {
            standard: ["boolean", ["feature-state", "highlighted-standard"], false],
            danger: ["boolean", ["feature-state", "highlighted-danger"], false],
            warning: ["boolean", ["feature-state", "highlighted-warning"], false],
        },
    },
    buildingClass: {
        normal: ["==", ["get", "class"], "normal"],
        main: ["==", ["get", "class"], "main-building"],
        parkingGarage: ["==", ["get", "class"], "parking-garage"],
        parkingLot: ["==", ["get", "class"], "parking-lot"],
    },
    type: {
        gebaude: ["==", ["get", "type"], "Gebäude"],
        parkplatz: ["==", ["get", "type"], "Parkplatz"],
    },
    state: {
        selected: ["to-boolean", ["feature-state", "selected"]],
        differentLevel: ["boolean", ["feature-state", "differentLevel"], false],
    },
    class: ["get", "class"],
    styleId: ["get", "styleId"],
    roomStates: EXPRESSION_PARTS.fillColor,
    floorStates: EXPRESSION_PARTS.fillColor,
    buildingStates: EXPRESSION_PARTS.fillColor,
};
